import {
  Component,
  Input,
  OnInit,
} from '@angular/core';

import {AddressListPage} from '../../pages/address-list/address-list.page';
import { NewCustomerPage } from 'src/app/pages/new-customer/new-customer.page';
import { DataService } from '../../services/data.service';

import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.scss'],
})
export class CustomerDetailsComponent implements OnInit {

  @Input() customers_list: any;
  @Input() ordersList: any;
  close_customerInfo = true;
  items: any;
  // order_item: any;
  
  constructor(public db: DataService,private modalCtrl:ModalController) {

   }

  ngOnInit() {

  }

  order_click(item) {
    this.items = item;
  }

  async presentModal() {
    
    const modal = await this.modalCtrl.create({
      component: AddressListPage,
      cssClass: 'my-custom-class',
      componentProps: {
        customer_id: this.customers_list,
      },
    });
     await modal.present();
  }


  async edit_customer(li) {
    let modal = await this.modalCtrl.create({
      component: NewCustomerPage,
      cssClass: "customer-popup",
      componentProps: {
         address_type: "Edit",
        address_info: li,
        customer_data: this.customers_list
      },
    });
    await modal.present();
    let data = await modal.onWillDismiss();
    // if (data.data == 'success') {
    //   this.get_customerslist();
    // }

  }

  close_button() {
    this.close_customerInfo = false;
  }
}
